/* Covenant Soil Bracelet delivery notice in the cart drawer (Sept 6, 2026 ten-color relaunch).
   cart-drawer.js rebuilds .cd-body innerHTML on every cart:updated and wipes Liquid rows,
   so the Liquid row in sections/cart-drawer.liquid covers first paint only; this file owns
   the row afterwards (same pattern as cyl-labor-hint.js). Inserted directly after the first
   bracelet line item. Teardown: remove this file and its script tag in sections/cart-drawer.liquid
   when the 10-business-day promise no longer applies. */
(function () {
  var PID = 14946849096047;
  var ROW_ID = 'tms-bracelet-delivery-row';
  var COPY = '<strong>Ships within 10 business days:</strong> the bracelet is packed in Jerusalem with its numbered certificate. Your order is reserved the moment it is placed.';

  function render(cart) {
    var existing = document.getElementById(ROW_ID);
    if (existing) existing.remove();
    if (!cart || !cart.items || !cart.items.length) return;
    var first = null;
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].product_id === PID) { first = cart.items[i]; break; }
    }
    if (!first) return;
    var host = document.querySelector('#cart-drawer .cd-items');
    if (!host) return;
    var div = document.createElement('div');
    div.id = ROW_ID;
    div.className = 'cd-item';
    div.style.cssText = 'background:#F5F1E8;border:1px solid #B8956A;padding:10px 14px;display:block;';
    div.innerHTML = '<span style="font-family:Arial,sans-serif;font-size:13px;color:#3E2723;">' + COPY + '</span>';
    var row = null;
    try { row = host.querySelector('.cd-item[data-cd-key="' + CSS.escape(first.key) + '"]'); } catch (e) {}
    if (row && row.parentNode === host) host.insertBefore(div, row.nextSibling);
    else host.appendChild(div);
  }

  document.addEventListener('cart:updated', function (e) {
    render(e.detail && e.detail.cart);
  });

  function boot() {
    /* If the Liquid row is already on the page (first paint), leave it; render only replaces after updates. */
    if (document.querySelector('#cart-drawer .cd-items [data-tms-bracelet-delivery]')) return;
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function () {});
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
